<div class="panel">
    <div class="title">{{ "dashboard.dashboardConfiguration.title" | transloco }}</div>
    <div class="configurations">
        <div class="form-group">
            <label>{{ "dashboard.dashboardConfiguration.nameLabel" | transloco }}</label>
            <cerrix-textfield
                [placeholder]="'dashboard.dashboardConfiguration.namePlaceholder' | transloco"
                data-uiid="dashboard-configuration-name"
                [(ngModel)]="config.name"
            ></cerrix-textfield>
        </div>

        <div class="form-group">
            <label>{{ "dashboard.dashboardConfiguration.descriptionLabel" | transloco }}</label>
            <cerrix-textarea [(ngModel)]="config.description"></cerrix-textarea>
        </div>

        <div class="form-group">
            <label>{{ "dashboard.dashboardConfiguration.iconLabel" | transloco }}</label>
            <cerrix-icon-picker [(value)]="config.icon"></cerrix-icon-picker>
        </div>

        <div class="row">
            <div class="col">
                <cerrix-checkbox
                    [(value)]="config.default"
                    (valueChange)="defaultChanged($event)"
                    [label]="'dashboard.dashboardConfiguration.personalDefaultLabel' | transloco"
                    data-uiid="dashboard-configuration-personal-default"
                ></cerrix-checkbox>
            </div>
            <div class="col">
                <cerrix-checkbox
                    [(value)]="config.favorite"
                    [disabled]="config.default"
                    [label]="'dashboard.dashboardConfiguration.favoriteLabel' | transloco"
                    data-uiid="dashboard-configuration-favorite"
                ></cerrix-checkbox>
            </div>
        </div>

        @if (
            permissions.RoleGroupLinker || permissions.SystemDefaultSetter || permissions.Publisher
        ) {
            <hr />
        }

        @if (permissions.RoleGroupLinker) {
            <div class="form-group">
                <label>{{ "dashboard.dashboardConfiguration.roleGroupLabel" | transloco }}</label>
                <ng-select
                    id="executableSelect"
                    name="executableSelect"
                    [items]="roleGroups"
                    [(ngModel)]="config.roleGroups"
                    bindLabel="Name"
                    bindValue="ID"
                    [closeOnSelect]="false"
                    [multiple]="true"
                    [clearable]="true"
                    [loading]="!roleGroups"
                >
                </ng-select>
            </div>
        }

        <div class="row">
            @if (permissions.SystemDefaultSetter) {
                <div class="col">
                    <cerrix-checkbox
                        [(value)]="config.systemDefault"
                        (valueChange)="defaultChanged($event)"
                        [label]="'dashboard.dashboardConfiguration.systemDefaultLabel' | transloco"
                        data-uiid="dashboard-configuration-system-default"
                    ></cerrix-checkbox>
                </div>
            }
            @if (permissions.Publisher) {
                <div class="col">
                    <cerrix-checkbox
                        [(value)]="config.public"
                        (valueChange)="defaultChanged($event)"
                        [label]="'dashboard.dashboardConfiguration.makePublicLabel' | transloco"
                        data-uiid="dashboard-configuration-make-public"
                    ></cerrix-checkbox>
                    <i
                        class="fas fa-info-circle ms-2"
                        [matTooltip]="'dashboard.dashboardConfiguration.publicInfoTooltip' | transloco"
                    ></i>
                </div>
            }
        </div>
    </div>
</div>
